import * as categoryConst from 'app/constants/categories';
import { position, getHeight } from 'app/utils/dom';
import * as testConst from 'app/constants/tests';
import { roundByStep } from 'app/utils/string';
import { Question } from 'types/test';

export const pointsTestToeic = (number: number): number => {
  switch (true) {
    case number == 0:
      return 5;
    case number >= 1 && number <= 75:
      return 5 * number + 10;
    case number >= 76 && number <= 95:
      return 5 * number + 15;
    case number >= 96 && number <= 100:
      return 5 * 96 + 15;
    default:
      return 990;
  }
}

export const minuteTest = (categoryId: number, countQuestion: number = 0) => {
  switch (Number(categoryId)) {
    case categoryConst.TOEIC_P1:
      return 5;
    case categoryConst.TOEIC_P2:
      return 12;
    case categoryConst.TOEIC_P3:
      return 20;
    case categoryConst.TOEIC_P4:
      return 13;
    case categoryConst.TOEIC_P5:
      return 15;
    case categoryConst.TOEIC_P6:
      return 10;
    case categoryConst.TOEIC_P7:
      return 50;
    case categoryConst.TOEIC_MINI:
      return 60;
    case categoryConst.TOEIC_FULL:
      return 120;
    case categoryConst.IELT_LISTEN:
      return 30;
    case categoryConst.IELT_READ:
      return 60;
    case categoryConst.IELT_WRITE:
      return 60;
    case categoryConst.IELT_SPEAK:
      return 15;
    default:
      return roundByStep(countQuestion, 5);
  }
}

export const scrollToQuestion = (questionId: string = '', categoryId: number = 0) => {
  setTimeout(() => {
    const top = questionId ? (window.scrollY + position(questionId).top) - getHeight('#header') - 10 : 0;

    if (categoryId == categoryConst.IELT_READ && questionId) {
      window.scrollTo({ top: 170, behavior: 'smooth' });
      const positionQuestion = window.scrollY + position(questionId).top - position('.form-ielts-read').top - 200;
      const formIeltRead = document.querySelector(".form-ielts-read");
      const scrollTop = (formIeltRead?.scrollTop || 0) + positionQuestion;
      formIeltRead?.scroll({ top: scrollTop, behavior: 'smooth' });
    } else {
      window.scrollTo({ top, behavior: 'smooth' });
    }
  }, 200)
}

export const genarateAnswersCorrect = (result: string = "") => {
  const answers = (replaceCharacter: string, splitCharacter: string) => {
    const answersCorrect: string[] = [];
    const resultArr = result.replace(replaceCharacter, '').split(splitCharacter);
    if (resultArr.length == 2) {
      resultArr[0].split('/').forEach((item1) => {
        resultArr[1].split('/').forEach((item2) => {
          const answer = `${item1} ${item2}`.replace(/\s\s+/g, ' ').trimStart()
          answersCorrect.push(answer);
        });
      })
    }

    return answersCorrect;
  }

  let answersArr: string[] = []
  if (!result.split('/').some(i => !Number.isInteger(Number(i)))) {
    answersArr.push(result);
  } else {
    if (result.indexOf('(') == 0) {
      answersArr = answers('(', ')');
    } else if (result.indexOf('(') > 0) {
      answersArr = answers(')', '(');
    } else {
      answersArr = result.split('/');
    }
  }

  return answersArr;
}

export const checkIsCorrect = (question: Question) => {
  let isCorrect = false;
  let infoText = '';

  switch (true) {
    case testConst.QUESTION_MULTI == question.type:
      const correctOptions = question.result?.split('$$') || [];
      const selectedOptions = question.answer?.split(',') || [];

      const totalCorrect = correctOptions.length;
      const totalMatched = selectedOptions.filter(option => correctOptions.includes(option)).length;

      isCorrect = totalMatched === totalCorrect && selectedOptions.length === totalCorrect;
      infoText = `(Correct ${totalMatched}/${totalCorrect})`;
      break;

    case testConst.QUESTION_INPUT == question.type:
      const acceptedAnswers = genarateAnswersCorrect(question.result).map(ans => ans.toLowerCase());
      const userAnswer = question?.answer?.trim().replace(/\s\s+/g, ' ').trimStart().toLowerCase();

      isCorrect = acceptedAnswers.includes(userAnswer || '') || acceptedAnswers.includes(`${userAnswer}.`);
      break;

    default:
      isCorrect = question.result === question.answer;
  }

  return { isCorrect, infoText }
}
